<ng-container>
  <form>
    <app-modal
        [open]="showModalConfirm"
        [id]="'modalConfirm'"
        [title]="modalTitle"
        [type]="type"
        (crossClick)="cancelOnClick()"
        (outsideClick)="cancelOnClick()">
      <ng-container ngProjectAs="[slot][body]">
        <p [attr.data-test]="modalName + '-desc-notifyText'" [innerText]="notifyText"></p>
      </ng-container>
      <ng-container ngProjectAs="[slot][footer]">
        @if (!hasSecondaryActionBtn) {
          <button
              [attr.data-test]="modalName + '-button-cancel'"
              type="reset"
              [innerText]="cancelBtnText"
              class="button button"
              data-dismiss="modal-dialog"
              (click)="cancelOnClick()">
          </button>
        } @else {
          <button
              [attr.data-test]="modalName + '-button-secondaryAction'"
              type="button"
              [innerText]="secondaryBtnText"
              class="button button--secondary"
              data-dismiss="modal-dialog"
              (click)="secondaryActionOnClick()">
          </button>
        }
        <button
            [attr.data-test]="modalName + '-button-primaryAction'"
            type="button"
            [innerText]="primaryBtnText"
            class="button button--primary"
            data-dismiss="modal-dialog"
            (click)="primaryActionOnClick()">
        </button>
      </ng-container>
    </app-modal>
  </form>
</ng-container>
